export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const EDIT_USER = 'EDIT_USER';
export const EDIT_USER_MASS = 'EDIT_USER_MASS';
export const CREATE_USER = 'CREATE_USER';
export const LOAD_USERS_LIST = 'LOAD_USERS_LIST';
export const EDIT_BALANCE = 'EDIT_BALANCE';
export const EDIT_SUPPORT_LIMIT = 'EDIT_SUPPORT_LIMIT';
export const RESET_SUPPORT_LIMIT = 'RESET_SUPPORT_LIMIT';
export const CHANGE_USER_WORK_STATUS = 'CHANGE_USER_WORK_STATUS';
export const LOAD_FINISHED_HISTORY = 'LOAD_FINISHED_HISTORY';
export const LOAD_FINISHED_USERS = 'LOAD_FINISHED_USERS';
export const RESET_FINISHED_HISTORY = 'RESET_FINISHED_HISTORY';
